module.exports = __webpack_public_path__ + "static/media/card-diamond.c055c89d.png";